import { constants } from "@/lib/constants";

export function isSmallScreen(windowWidth) {
  return windowWidth <= constants.smallScreenBreakPoint;
}

/**
 * This method will returns true when object any attr value is null/""/undefined
 * @param obj
 * @return true/false
 */
export function isEmptyObject(obj) {
  const emptyList = Object.values(obj).filter(x => x === null || x === "" || x === undefined);
  return emptyList.length > 0;
}

export function trackAnalyticsEvent(eventName, params = {}) {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", eventName, params);
  }
}
